/*
 *
 * AmbassadorsImport constants
 *
 */

export const DEFAULT_ACTION = "app/AmbassadorsImport/DEFAULT_ACTION"

export const GET_TEMPLATE_WATCHER = "app/AmbassadorsImport/GET_TEMPLATE_WATCHER"
export const GET_TEMPLATE_FAILED = "app/AmbassadorsImport/GET_TEMPLATE_FAILED"
export const GET_TEMPLATE_SUCCESS = "app/AmbassadorsImport/GET_TEMPLATE_SUCCESS"

export const UPLOAD_TEMPLATE_WATCHER =
  "app/AmbassadorsImport/UPLOAD_TEMPLATE_WATCHER"
export const UPLOAD_TEMPLATE_SUCCESS =
  "app/AmbassadorsImport/UPLOAD_TEMPLATE_SUCCESS"
export const UPLOAD_TEMPLATE_FAILED =
  "app/AmbassadorsImport/UPLOAD_TEMPLATE_FAILED"
